<template>
    <tailwind-layout title="Property Payment">
        <div class="bg-white border border-gray-200 shadow-xl sm:rounded-lg p-6 mt-9 flex justify-center">
            <div class="text-center w-3/4">
                <h1 class="text-2xl font-bold text-blue-600 mb-4">You’ve Been Unsubscribed</h1>
                <p class="text-lg text-gray-600 mb-4">You’ve successfully unsubscribed from this specific email.</p>
                <p class="text-lg text-gray-600">If you’d like to update other email preferences or continue receiving different types of updates, click the button below to manage your email preferences.</p>
                <inertia-link :href="route('email-preferences')" class="mt-5 w-2/5 sm:ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-900 bg-rent-risk-blue-400 hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">
                    Manage Email Preferences
                </inertia-link>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue';
import FormButton from '@/Shared/FormButton.vue';
import SelectInput from '@/Shared/SelectInput.vue';
import SwitchGroup from "@/Shared/SwitchGroup.vue";
import RadioGroup from "@/Shared/RadioGroup.vue";
import BannedCitiesAndStates from "@/Shared/BannedCitiesAndStates.vue";
import axios from "axios";

export default {
    props: {
    },
    components: {
        TailwindLayout,
        FormButton,
        SelectInput,
        RadioGroup,
    },
    remember: 'form',
}
</script>
